import { motion } from "framer-motion";
import { AnimatedText } from "../ui/animated-text";
import { ShinyButton } from "../ui/shiny-button";

export function InstallationSection() {
    const installers = [
        {
            name: "VBS Taximeter Datensicherung GmbH",
            city: "Berlin",
            address: "Buckower Chaussee 110–113",
            postalCode: "12277 Berlin-Marienfelde",
            country: "Deutschland",
            phone: { display: "030 959982020", link: "+4930959982020" },
        },
        {
            name: "Traumcar Autovermietung und Taxiverleih Gmbh",
            city: "München",
            address: "Engelhardstraße 6",
            postalCode: "81369 München",
            country: "Deutschland",
            phone: { display: "089-163004", link: "089163004" },
        },
        {
            name: "Taxitech Handelsges. mbH",
            city: "Hamburg",
            address: "Sommerkamp 31a",
            postalCode: "22335 Hamburg",
            country: "Deutschland",
            phone: { display: "040 51311288", link: "04051311288" },
        },
        {
            name: "Taxi Schiebel®",
            city: "Rottenburg am Neckar",
            address: "Lippstr 13",
            postalCode: "72108 Rottenburg am Neckar",
            country: "Deutschland",
            phone: { display: "07472/6225", link: "+4974726225" },
        },
        {
            name: "meycar GmbH",
            city: "Frankfurt a. Main",
            address: "Morsestr. 44",
            postalCode: "60486 Frankfurt a. Main",
            country: "Deutschland",
            phone: null,
        },
    ];

    return (
        <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 overflow-hidden bg-gradient-to-b from-transparent via-white/[0.02] to-transparent">
            <div className="container mx-auto max-w-4xl">
                <div className="text-center mb-12">
                    <AnimatedText
                        lines={["Installation & Verfügbarkeit"]}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 tracking-tight"
                        direction="up"
                        as="h2"
                    />
                    <p className="text-base sm:text-lg text-gray-400 max-w-2xl mx-auto mb-6 sm:mb-8">
                        Professionelle Installation an mehreren Standorten in Deutschland
                    </p>
                    <div className="flex justify-center">
                        <ShinyButton glow={true} className="min-h-[44px]" onClick={() => {
                            window.location.hash = "#installation";
                        }}>
                            Einbauer? Hier registrieren.
                        </ShinyButton>
                    </div>
                </div>

                <div className="space-y-0 mt-12">
                    {installers.map((installer, index) => (
                        <motion.div
                            key={installer.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="py-8 sm:py-10 px-6 sm:px-8 border-b border-white/10 last:border-b-0 hover:bg-white/[0.02] transition-colors"
                        >
                            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
                                <div className="flex-1">
                                    <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">
                                        {installer.name}
                                    </h3>
                                    <div className="space-y-1 text-base sm:text-lg text-gray-300">
                                        <p>{installer.address}</p>
                                        <p>{installer.postalCode}</p>
                                        <p className="text-gray-400">{installer.country}</p>
                                    </div>
                                </div>
                                <div className="flex flex-col items-start sm:items-end gap-2">
                                    <div className="px-3 py-1 rounded-full bg-white/5 border border-white/10 text-sm font-medium text-gray-300">
                                        {installer.city}
                                    </div>
                                    {installer.phone && (
                                        <a
                                            href={`tel:${installer.phone.link}`}
                                            className="text-base sm:text-lg font-medium text-white hover:text-gray-300 transition-colors"
                                        >
                                            {installer.phone.display}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}

